<template>
    <div class="standings-tab">
        <standings-table :standings="standings" />
    </div>
</template>

<script setup>
import StandingsTable from '@/components/features/standings/StandingsTable.vue';

const props = defineProps({
    standings: {
        type: Array,
        required: true,
        default: () => []
    }
});
</script>


